/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from "react";

import PaymentTable from "../tables/PaymentTable";
import PaymentTableDeferred from "../tables/PaymentTableDeferred";
import TaxesTable from "../tables/TaxesTable";
import ImportTable from "../tables/ImportTable";
import ImportPOTable from "../tables/ImportPOTable";
import CategoriesTable from "../tables/CategoriesTable";
import CategoriesTableDeferred from "../tables/CategoriesTableDeferred";
import CategoriesTableExtended from "../tables/CategoriesTableExtended";
import CardsTableMulti from "../tables/CardsTableMulti";
import CategoriesTableRounded from "../tables/CategoriesTableRounded";
import CardsTables from "../tables/CardsTable";
import WithoutCategoriesTable from "../tables/WithoutCategoriesTable";
// import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
import { useSelector } from "react-redux";
import Reports from "../tables/Reports";
import TableRenderers from "../ui/reports/TableRenderers";
import DummyComponent from "../tables/DummyComponent";
import Loader from "../Loader";
import { isAcombaIntegration, isAcombaSdkIntegration } from "../../utils/d365Dimensions";

const TableContent = () => {
  const [sortState, setSortState] = useState([0, 0, 0, 0, 0, 0]);
  const [notes, setNotes] = useState([]);
  const [settings, setSettings] = useState({});
  const ui = useSelector((state) => state.ui);
  const database = useSelector((state) => state.database);
  const scrollRef = useRef({ current: 0 });
  const [scrollState, setScrollState] = useState(true);

  const handleScroll = () => {
    if (scrollRef.current.scrollTop > 0) {
      if (scrollState !== false) setScrollState(false);
    } else {
      if (scrollState !== true) setScrollState(true);
    }
  };

  const changeSortState = (x) => {
    const newSortState = Array(9).fill(0);
    newSortState[x] = sortState[x] === 0 ? 1 : sortState[x] === 1 ? 2 : 0;
    setSortState([...newSortState]);
  };

  //console.log("Current company type:", database.currentCompany.type);
  //console.log("ui.table value:", ui.table);
  //console.log("Reports data:", database.currentShop.reports);

  const renderTable = () => {
    const search = (ui.search || "").toLowerCase();
    const isRestaurantK = database.currentCompany.type === "RESTOK";
    const acombagoIntegration = isAcombaIntegration(database.currentCompany, database.currentShop);
    const loadingTables = database.loadingTables || {};

    const renderKLoader = (key) =>
      isRestaurantK && loadingTables[key] ? <Loader /> : null;

    switch (ui.table) {
      // 0: Payments
      case 0:
        if (renderKLoader("payments")) return renderKLoader("payments");
        return (
          <PaymentTable
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(database.currentShop.payments || []).filter(
              (item) =>
                (item?.account_id || "").toLowerCase().includes(search) ||
                (item?.account_description || "").toLowerCase().includes(search) ||
                String(item?.paymenttype_id || "").includes(search) ||
                (item?.paymenttypeid_name || "").toLowerCase().includes(search)
            )}
          />
        );

      // 1: Categories
      case 1:
        if (renderKLoader("categories")) return renderKLoader("categories");
        if (ui.extendTable && database.currentCompany.type === "RETAIL") {
          return (
            <CategoriesTableExtended
              scrollPos={scrollState}
              sortState={sortState}
              changeSortState={changeSortState}
              data={(database.currentShop.categories || []).filter(
                (item) =>
                  (item?.account_id || "").toLowerCase().includes(search) ||
                  (item?.account_description || "").toLowerCase().includes(search) ||
                  String(item?.category_id || "").includes(search) ||
                  (item?.category_name || "").toLowerCase().includes(search) ||
                  String(item?.parentid || "").includes(search) ||
                  String(item?.cogs || "").includes(search) ||
                  String(item?.cogs_description || "").includes(search) ||
                  String(item?.cogs2 || "").includes(search) ||
                  String(item?.cogs_description2 || "").includes(search)
              )}
            />
          );
        }

        return (
          <CategoriesTable
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(database.currentShop.categories || []).filter(
              (item) =>
                (item?.account_id || "").toLowerCase().includes(search) ||
                (item?.account_description || "").toLowerCase().includes(search) ||
                String(item?.category_id || "").includes(search) ||
                (item?.category_name || "").toLowerCase().includes(search) ||
                String(item?.parentid || "").includes(search)
            )}
          />
        );

      // 2: Categories (Multi GL)
      case 2:
        return <CardsTableMulti data={database.currentShop.categoriesMulti} />;

      // 3: Categories (round)
      case 3:
        return (
          <CategoriesTableRounded
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(database.currentShop.categoriesRound || []).filter(
              (item) =>
                (item?.account_id || "").toLowerCase().includes(search) ||
                (item?.account_description || "").toLowerCase().includes(search) ||
                String(item?.category_id || "").includes(search) ||
                (item?.category_name || "").toLowerCase().includes(search) ||
                String(item?.parentid || "").includes(search)
            )}
          />
        );

      // 4: Other (Over/Short, Tips)
      case 4:
        if (renderKLoader("other")) return renderKLoader("other");
        return <CardsTables data={database.currentShop.other} />;

      // 5: Items without category
      case 5:
        return (
          <WithoutCategoriesTable
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(database.currentShop.less || []).filter(
              (item) =>
                (item?.description || "").toLowerCase().includes(search) ||
                (item?.account_description || "").toLowerCase().includes(search) ||
                String(item?.category_id || "").includes(search) ||
                (item?.category_name || "").toLowerCase().includes(search) ||
                String(item?.itemid || "").includes(search)
            )}
          />
        );

      // 6: Reports (RETAIL/RETAILX)
      case 6:
        if (database.currentCompany.type === "RETAIL" || database.currentCompany.type === "RETAILX") {
          return (
            <Reports
              scrollPos={scrollState}
              sortState={sortState}
              changeSortState={changeSortState}
              data={database.currentShop.reports}
              rows={["transaction_date", "gl_number", "gl_description", "debit", "credit", "total"]}
              aggregatorName="Sum"
              vals={["total"]}
              renderers={TableRenderers}
              hiddenAttributes={["pvtRenderers", "pvtAxisContainer", "pvtVals", "pvtAxisContainer"]}
            />
          );
        }
        return null;

      // 7: Taxes
      case 7:
        if (renderKLoader("taxes")) return renderKLoader("taxes");
        return (
          <TaxesTable
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(Array.isArray(database.currentShop.taxes) ? database.currentShop.taxes : []).filter(
              (item) =>
                (item?.account_id || "").toLowerCase().includes(search) ||
                (item?.account_description || "").toLowerCase().includes(search) ||
                String(item?.tax_id || "").includes(search) ||
                (item?.tax_name || "").toLowerCase().includes(search)
            )}
          />
        );

      // 8: Imports (RETAIL/RETAILX)
      case 8:
        if (database.currentCompany.type === "RETAIL" || database.currentCompany.type === "RETAILX") {
          const imports = Array.isArray(database?.currentShop?.imports)
            ? database.currentShop.imports
            : Object.values(database?.currentShop?.imports || {});

          return (
            <ImportTable
              scrollPos={scrollState}
              sortState={sortState}
              changeSortState={changeSortState}
              data={(imports || []).filter(
                (item) =>
                  (item?.account_id || "").toLowerCase().includes(search) ||
                  (item?.account_description || "").toLowerCase().includes(search) ||
                  String(item?.tax_id || "").includes(search) ||
                  (item?.tax_name || "").toLowerCase().includes(search)
              )}
            />
          );
        }
        return null;

      // 13: Independent Imports (PO), available for Acomba SDK retail companies.
      case 13:
        if (database.currentCompany.type === "RETAIL" &&
            isAcombaSdkIntegration(database.currentCompany, database.currentShop)) {
          const importsPO = Array.isArray(database.currentShop.importsPO)
            ? database.currentShop.importsPO
            : Object.values(database.currentShop.importsPO || {});
          return (
            <ImportPOTable
              scrollPos={scrollState}
              sortState={sortState}
              changeSortState={changeSortState}
              data={importsPO.filter((item) =>
                [item.order_id, item.refNum, item.vendorName, item.shopName, item.vendorCurrencyCode]
                  .some(value => String(value ?? "").toLowerCase().includes(search))
              )}
            />
          );
        }
        return null;

      // 9: Imports (RESTO/RESTOK)
      case 9:
        if (database.currentCompany.type === "RESTO" || database.currentCompany.type === "RESTOK") {
          return (
            <ImportTable
              scrollPos={scrollState}
              sortState={sortState}
              changeSortState={changeSortState}
              data={(database.currentShop.imports || []).filter(
                (item) =>
                  (item?.account_id || "").toLowerCase().includes(search) ||
                  (item?.account_description || "").toLowerCase().includes(search) ||
                  String(item?.tax_id || "").includes(search) ||
                  (item?.tax_name || "").toLowerCase().includes(search)
              )}
            />
          );
        }
        return null;

      // 10: Reports (RESTO/RESTOK)
      case 10:
        if (database.currentCompany.type === "RESTO" || database.currentCompany.type === "RESTOK") {
          return <Reports />;
        }
        return null;

      // 11: Payments (deferred)
      case 11:
        if (acombagoIntegration) return null;
        return (
          <PaymentTableDeferred
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(database.currentShop.paymentsDeferred || []).filter(
              (item) =>
                (item?.account_id_deferred || "").toLowerCase().includes(search) ||
                (item?.account_description_deferred || "").toLowerCase().includes(search) ||
                String(item?.paymenttype_id || "").includes(search) ||
                (item?.paymenttypeid_name || "").toLowerCase().includes(search)
            )}
          />
        );

      // 12: Categories (deferred)
      case 12:
        if (acombagoIntegration) return null;
        return (
          <CategoriesTableDeferred
            scrollPos={scrollState}
            sortState={sortState}
            changeSortState={changeSortState}
            data={(database.currentShop.categoriesDeferred || []).filter(
              (item) =>
                (item?.account_id_deferred || "").toLowerCase().includes(search) ||
                (item?.account_description_deferred || "").toLowerCase().includes(search) ||
                String(item?.category_id || "").includes(search) ||
                (item?.category_name || "").toLowerCase().includes(search) ||
                String(item?.parentid || "").includes(search)
            )}
          />
        );

      default:
        return <DummyComponent />;
    }
  };

  return (
    <div className="table-content" onScroll={handleScroll} ref={scrollRef}>
      {renderTable()}
    </div>
  );
};

export default TableContent;
